// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var DevicePixelRatio = require("../v5/common/DevicePixelRatio.bs.js");
var RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

var Types = {};

function unwrap_response_updateMarketingProfileMemberPhoto(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["MarketingProfileMemberPhotoUpdated"]);
}

var variablesConverter = {"profilePhotoWithOriginalInput":{"originalPhoto":{"r":"profilePhotoInput"},"croppedPhoto":{"r":"profilePhotoInput"}},"updateMarketingProfileMemberPhotoInput":{"profilePhoto":{"r":"profilePhotoWithOriginalInput"}},"profilePhotoInput":{},"__root":{"input":{"r":"updateMarketingProfileMemberPhotoInput"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

var wrapResponseConverter = {"__root":{"updateMarketingProfileMemberPhoto_MarketingProfileMemberPhotoUpdated_member":{"f":""},"updateMarketingProfileMemberPhoto":{"u":"response_updateMarketingProfileMemberPhoto"}}};

var wrapResponseConverterMap = {
  response_updateMarketingProfileMemberPhoto: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

var responseConverter = {"__root":{"updateMarketingProfileMemberPhoto_MarketingProfileMemberPhotoUpdated_member":{"f":""},"updateMarketingProfileMemberPhoto":{"u":"response_updateMarketingProfileMemberPhoto"}}};

var responseConverterMap = {
  response_updateMarketingProfileMemberPhoto: unwrap_response_updateMarketingProfileMemberPhoto
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

var Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

function imageContentType_decode($$enum) {
  if ($$enum === "PNG" || $$enum === "JPEG" || $$enum === "GIF" || $$enum === "WEBP") {
    return $$enum;
  }
  
}

function imageContentType_fromString(str) {
  return imageContentType_decode(str);
}

var Utils = {
  imageContentType_decode: imageContentType_decode,
  imageContentType_fromString: imageContentType_fromString
};

var providedVariablesDefinition = {
  __relay_internal__pv__DevicePixelRatio: {
    providedVariable: DevicePixelRatio.get,
    get: DevicePixelRatio.get
  }
};

function makeNode(providedVariablesDefinition) {
  return ((function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MarketingProfileMemberPhotoFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateMarketingProfileMemberPhoto",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MarketingProfileMember",
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "MarketingProfileMemberPhotoForm_agentMarketingProfile"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "MarketingProfileMemberPhotoUpdated",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__DevicePixelRatio"
      }
    ],
    "kind": "Operation",
    "name": "MarketingProfileMemberPhotoFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateMarketingProfileMemberPhoto",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MarketingProfileMember",
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "displayName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProfilePhoto",
                    "kind": "LinkedField",
                    "name": "profilePicture",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "ratio",
                            "variableName": "__relay_internal__pv__DevicePixelRatio"
                          },
                          {
                            "kind": "Literal",
                            "name": "width",
                            "value": 96
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      },
                      (v3/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nodeId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "MarketingProfileMemberPhotoUpdated",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7547d552ebb045378b6bb12449fa8cdc",
    "id": null,
    "metadata": {},
    "name": "MarketingProfileMemberPhotoFormMutation",
    "operationKind": "mutation",
    "text": "mutation MarketingProfileMemberPhotoFormMutation(\n  $input: UpdateMarketingProfileMemberPhotoInput!\n  $__relay_internal__pv__DevicePixelRatio: Float!\n) {\n  updateMarketingProfileMemberPhoto(input: $input) {\n    __typename\n    ... on MarketingProfileMemberPhotoUpdated {\n      member {\n        ...MarketingProfileMemberPhotoForm_agentMarketingProfile\n        nodeId\n      }\n    }\n  }\n}\n\nfragment MarketingProfileMemberPhotoForm_agentMarketingProfile on MarketingProfileMember {\n  firstName\n  displayName\n  ...MarketingProfileMemberPhotoForm_currentPhoto_marketingProfileMember\n  ...MarketingProfileMemberPhotoForm_changeProfilePhoto_marketingProfileMember\n}\n\nfragment MarketingProfileMemberPhotoForm_changeProfilePhoto_marketingProfileMember on MarketingProfileMember {\n  id\n  profilePicture {\n    __typename\n  }\n}\n\nfragment MarketingProfileMemberPhotoForm_currentPhoto_marketingProfileMember on MarketingProfileMember {\n  profilePicture {\n    url(width: 96, ratio: $__relay_internal__pv__DevicePixelRatio)\n    id\n  }\n}\n",
    "providedVariables": providedVariablesDefinition
  }
};
})());
}

var node = makeNode(providedVariablesDefinition);

var wrap_response_updateMarketingProfileMemberPhoto = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_updateMarketingProfileMemberPhoto = unwrap_response_updateMarketingProfileMemberPhoto;
exports.wrap_response_updateMarketingProfileMemberPhoto = wrap_response_updateMarketingProfileMemberPhoto;
exports.Internal = Internal;
exports.Utils = Utils;
exports.providedVariablesDefinition = providedVariablesDefinition;
exports.node = node;
/* node Not a pure module */
